let contrastCookie = document.cookie.split('; ').find(row => row.startsWith('contrast='));
if(contrastCookie) {
    contrastCookie = contrastCookie.split('=')[1];
    $('body').addClass(contrastCookie);
}
$(document).on('click', '#contrast-switch', function (e) {
    e.preventDefault();
    if(contrastCookie === "dark") {
        document.cookie = "contrast=light; path=/; max-age=31536000";
        contrastCookie = "light"
        document.body.classList.remove('dark')
        document.body.classList.add('light')
    } else {
        document.cookie = "contrast=dark; path=/; max-age=31536000";
        contrastCookie = "dark"
        document.body.classList.remove('light')
        document.body.classList.add('dark')
    }

});